import PropTypes from 'prop-types';
import styles from './button-view-glossary.module.scss';
import Icon from '../icon/index';
import InteractiveElement from '../interactive-element';
import useSideRailContext from '../../../stores/profile/use-side-rail-context';

const ButtonViewGlossary = ({
  children = '',
  className,
  glossarySection = '',
  iconStyle,
  isScreener = false,
  solid
}) => {
  const { glossary = {} } = useSideRailContext() || {};

  const analyticsAttributes = isScreener
    ? {
      'data-analytics-componenttype': 'TextLink',
      'data-analytics-linkname': 'GlossaryExpand',
      'data-analytics-section': 'component'
    }
    : { 'data-analytics-linkname': 'View Glossary' };
  const ariaLabel = glossarySection ? `Open Glossary: ${glossarySection} section` : 'Open Glossary';
  const classes = [className, styles.button].filter(Boolean).join(' ');

  return (
    <InteractiveElement
      as="button"
      className={classes}
      {...analyticsAttributes}
      onClick={() => {
        if (glossary?.show) glossary.show(glossarySection);
      }}
      aria-label={ariaLabel}
      tabIndex={0}
      role="button"
    >
      <Icon
        style={iconStyle}
        variant={solid ? 'QuestionMarkCircledSolid' : 'QuestionMarkCircled'}
      />
      {children}
    </InteractiveElement>
  );
};

ButtonViewGlossary.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  glossarySection: PropTypes.string,
  iconStyle: PropTypes.object,
  isScreener: PropTypes.bool,
  solid: PropTypes.bool
};

export default ButtonViewGlossary;
